/** Shared XFORMA identity. Decorative artwork has one accessible name. */
import { href } from '../lib/router.js';
export function BrandWordmark() {
  return <span className="xc-wordmark" aria-hidden="true"><img src="/brand/xforma-mark.svg" width="32" height="32" alt="" /><span>XFORMA</span></span>;
}
export function BrandMark() {
  return <><BrandWordmark /><span className="xc-sr-only">XFORMA</span></>;
}
export function BrandLink({ to = '/', label = 'XFORMA หน้าแรก' }: { to?: string; label?: string }) {
  return <a href={href(to)} className="xc-logo"><BrandWordmark /><span className="xc-sr-only">{label}</span></a>;
}
